import { useNavigate } from "react-router";
import { Box, Stack } from "@mui/material";
import { FC } from "react";
import { useAppNavigate } from "../../../_hooks/use-app-navigate";
import BotCard from "./BotCard";
import { AutoStrategyInfo, FuturesBotInfo } from "../types";
import { useTranslation } from "react-i18next";
import ProfitInfoSlider from "./ProfitInfoSlider/ProfitInfoSlider";

interface BotListProps {
  accounts: number;
  futuresBots: FuturesBotInfo;
  autoStrategies: AutoStrategyInfo;
}

const BotList: FC<BotListProps> = (props: BotListProps) => {
  const navigate = useNavigate();
  const appNavigate = useAppNavigate();
  const { t } = useTranslation("bots");

  const totalFuturesBots =
    props.futuresBots.futuresGrid.activeTotal + props.futuresBots.futuresGrid.archivedTotal;

  const totalAutoStrategies =
    props.autoStrategies.strategies[0].active + props.autoStrategies.strategies[0].archived;

  const totalProfit = props.futuresBots.totalProfit + props.autoStrategies.totalProfit;

  const onClickFuturesBot = () => {
    if (!totalFuturesBots) {
      navigate("/choosepair/bot");
    } else {
      appNavigate.botList("active");
    }
  };

  const onClickStrategiesBot = () => {
    if (!totalAutoStrategies) {
      appNavigate.createStrategy();
    } else {
      appNavigate.strategyList("active");
    }
  };

  return (
    <Box
      sx={{
        opacity: props.accounts > 0 ? "100%" : "50%",
      }}
    >
      <ProfitInfoSlider
        totalProfit={totalProfit}
        gridPnl={props.futuresBots.gridPnl}
        realizedPnl={props.futuresBots.realizedPnl}
      />
      <Stack direction={"column"} spacing={"10px"} sx={{ paddingTop: 3 }}>
        <BotCard
          type="futures"
          title={t("futuresBots")}
          activeCount={props.futuresBots.futuresGrid.activeTotal}
          archivedCount={props.futuresBots.futuresGrid.archivedTotal}
          onClickCard={onClickFuturesBot}
          disabled={!props.accounts}
        />
        <BotCard
          type="auto-strategies"
          title={t("autoStrategies")}
          activeCount={props.autoStrategies.strategies[0]?.active}
          archivedCount={props.autoStrategies.strategies[0]?.archived}
          onClickCard={onClickStrategiesBot}
          disabled={!props.accounts}
        />
        <BotCard type="spot-bots" title={t("spotBots")} isSoon />
      </Stack>
    </Box>
  );
};

export default BotList;
